import React, { useCallback } from 'react';
import { QuestionProps } from '../Quiz/Quiz';
import TinderCard from 'react-tinder-card';
import { useWindowSize } from '../../hooks';

let answeredYes: number[] = [];
let answeredItems = 0;

interface movedItem {
  id: number;
  direction: string;
}

const TinderQ: React.FC<QuestionProps> = ({ question, nextSlide, notes, onAnswerSelect }) => {
  const [proccessed, setProccessed] = React.useState<number[]>([]);
  const [toMove, setToMove] = React.useState<movedItem|null>(null);
  const size = useWindowSize();
  const swipeOrDrag = size.width > 768 ? 'DRAG' : 'SWIPE';

  const answerReversed = [...question.answers].reverse();

  const swiped: (d: string, id: number) => void = useCallback(
    (direction, id) => {
      answeredItems++;
      setProccessed([...proccessed, id]);
      if (direction === 'right') {
        answeredYes = [...answeredYes, id];
      }
    },
    [proccessed],
  );

  const store: () => void = () => {
    onAnswerSelect(question.id, answeredYes, true);
    nextSlide();
  };

  const outOfFrame = () => {
    console.log(' left the screen!');
  };

  return (
    <div className={'ma-slide'}>
      <h2>{question.question}</h2>
      <p className={'instructions'}>{swipeOrDrag} RIGHT IF HIGH-PRIORITY, {swipeOrDrag} LEFT IF LOW-PRIORITY</p>

      <div className={`answers-wrapper tinder ${size.width < 768 ? 'no-arrows': ''}`}>
        {answeredItems < answerReversed.length && (
              <div className={'prev-cart'} onClick={() => {
                  setToMove({id: question.answers[answeredItems].id, direction: 'left'});
                  swiped('left', question.answers[answeredItems].id)
               }} >&lt;
              </div>
        )}
        {answerReversed.map((answer, index) => (
          <div
            key={`item-${question.id}-${answer.id}`} 
            className={`tinder-wrap titem-${index} ${toMove && toMove.id === answer.id ? 'tomove': ''} ${toMove && toMove.direction === 'right' ? 'right': ''} ${toMove && toMove.id > answer.id ? 'invisible': ''}`}
          >
            <TinderCard
              onCardLeftScreen={outOfFrame}
              onSwipe={(dir) => swiped(dir, answer.id)}
            >
              <div className={'answer'}>{answer.answer}</div>
            </TinderCard>
          </div>
        ))}
        {answeredItems < answerReversed.length && (
          <div onClick={() => {
            setToMove({id: question.answers[answeredItems].id, direction: 'right'});
            swiped('right', question.answers[answeredItems].id)
          }} className={'next-cart'}>&gt;</div>
        )}
      </div>
      <p>{answeredItems === question.answers.length ? notes : '\u00A0'}</p>
      <button className={'next'} disabled={answeredItems === question.answers.length ? false : true} onClick={store}>
        Next &gt;
      </button>
    </div>
  );
};

export default TinderQ;
